import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    errorTextJoin: ': ',
    fallbackErrorMessage: 'There was a problem with your document',
  },
  fr: {
    errorTextJoin: ' : ',
    fallbackErrorMessage: 'Un problème est survenu avec votre document',
  },
});
